import { createEnumMap } from '../../../business/filterOverlay/components/configs/FilterConfigs';

const enums = { orientation: ['vertical', 'horizontal'] };

const STEPPER_ORIENTATION = createEnumMap(enums.orientation);

export { STEPPER_ORIENTATION };
